export type TierCardTheme = {
  readonly bg: string;
  readonly ink: string;
  readonly titleAccent?: string;
};

const DARK_STACK_INK = '#1b1c1f';

export function getTierStackCardTheme(tierName: string): TierCardTheme | null {
  const token = tierName.trim().toLowerCase();

  if (token.includes('basic')) {
    return {
      bg: '#a64c44',
      ink: DARK_STACK_INK,
    };
  }

  if (token.includes('silver')) {
    return {
      bg: '#969696',
      ink: DARK_STACK_INK,
      titleAccent: '#a64c44',
    };
  }

  if (token.includes('gold')) {
    return {
      bg: '#e0a15e',
      ink: DARK_STACK_INK,
    };
  }

  return null;
}
